import { Link } from "react-router";
import type { ReactNode } from "react";
import styles from "@styles/site.module.css";

type CtaProps = {
  to: string;
  children: ReactNode;
  variant?: "primary" | "ghost";
  size?: "md" | "sm";
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  external?: boolean;
};

export function Cta({
  to,
  children,
  variant = "primary",
  size = "md",
  iconLeft,
  iconRight,
  external,
}: CtaProps) {
  const className = [
    styles.cta,
    variant === "primary" ? styles.ctaPrimary : styles.ctaGhost,
    size === "sm" ? styles.ctaSm : "",
  ]
    .filter(Boolean)
    .join(" ");

  const inner = (
    <>
      {iconLeft}
      <span>{children}</span>
      {iconRight}
    </>
  );

  if (external) {
    return (
      <a className={className} href={to} target="_blank" rel="noreferrer">
        {inner}
      </a>
    );
  }

  return (
    <Link className={className} to={to}>
      {inner}
    </Link>
  );
}
